/**
 * View component for /user-modules/new
 *
 * Creates a new userModule from a copy of the defaultItem in the userModule reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userModuleActions from '../userModuleActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userModule components
import UserModuleForm from '../components/UserModuleForm.js.jsx';
import UserModuleLayout from '../components/UserModuleLayout.js.jsx';

class CreateUserModule extends Base {
  constructor(props) {
    super(props);
    this.state = {
      userModule: _.cloneDeep(this.props.defaultUserModule)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newUserModuleState = _.update( this.state.userModule, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userModule :newUserModuleState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userModuleActions.sendCreateUserModule(this.state.userModule)).then((action) => {
      if(action.success) {
        dispatch(userModuleActions.invalidateList());
        history.push(`/user-modules/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { userModule } = this.state;
    const isEmpty = (userModule.name === null || userModule.name === undefined);
    return (
      <UserModuleLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <UserModuleForm
                userModule={userModule}
                cancelLink="/user-modules"
                formTitle="Create User Module"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </UserModuleLayout>
    )
  }
}

CreateUserModule.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultUserModule: store.userModule.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateUserModule)
);



// WEBPACK FOOTER //
// modules/userModule/views/CreateUserModule.js.jsx